<div class="modal-header">
    <h4 class="modal-title">Create Site</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    @if (step === 1) {
        <h5>Step 1 of 3 - Name the site</h5>
        <label class="form-label">Job</label>
        <select class="form-select mb-2" [(ngModel)]="job" (ngModelChange)="jobChanged()">
            <option value="">Select a job</option>
            @for (option of jobs; track option.id) {
                <option [value]="option.id">{{ option.id.trim() }} {{ option.name }}</option>
            }
        </select>
        <label class="form-label">Site name</label>
        <input class="form-control" [(ngModel)]="name" />
    }
    @if (step === 2) {
        <h5>Step 2 of 3 - Locate the site</h5>
        <div class="d-flex gap-2 mb-2">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="useDevice()">Use device location</button>
            <input class="form-control form-control-sm" [(ngModel)]="search" placeholder="Search an address" />
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="searchAddress()">Search</button>
        </div>
        @for (hit of hits; track hit.lat + hit.lon) {
            <button type="button" class="btn btn-link btn-sm d-block text-start" (click)="useHit(hit)">{{ hit.display_name }}</button>
        }
        <div class="row g-2 mb-2">
            <div class="col"><label class="form-label">Latitude</label><input class="form-control" type="number" [(ngModel)]="latitude" /></div>
            <div class="col"><label class="form-label">Longitude</label><input class="form-control" type="number" [(ngModel)]="longitude" /></div>
        </div>
        <app-swppp-map [latitude]="latitude" [longitude]="longitude" (picked)="onPicked($event)"></app-swppp-map>
        <div class="small text-muted mt-1">{{ address }}</div>
    }
    @if (step === 3) {
        <h5>Step 3 of 3 - Site details</h5>
        <div class="row g-2">
            <div class="col"><label class="form-label">Acreage</label><input class="form-control" type="number" [(ngModel)]="acreage" /></div>
            <div class="col"><label class="form-label">Disturbed acreage</label><input class="form-control" type="number" [(ngModel)]="disturbedAcreage" /></div>
        </div>
        <label class="form-label mt-2">MS4</label>
        <input class="form-control" [(ngModel)]="ms4" />
        <div class="mt-3">
            <div class="d-flex justify-content-between">
                <strong>Site contacts</strong>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addContact()" [disabled]="contacts.length >= 3">Add contact</button>
            </div>
            @for (contact of contacts; track $index) {
                <div class="row g-2 mt-1">
                    <div class="col"><input class="form-control" placeholder="Name" [(ngModel)]="contact.name" /></div>
                    <div class="col"><input class="form-control" placeholder="Phone" [(ngModel)]="contact.phone" /></div>
                    <div class="col"><input class="form-control" placeholder="Email" [(ngModel)]="contact.email" /></div>
                </div>
            }
        </div>
    }
    @if (step === 4) {
        <h5>Review</h5>
        <p><strong>{{ name }}</strong><br />{{ job }}<br />{{ address }}</p>
        <app-swppp-map [latitude]="latitude" [longitude]="longitude" [zoom]="14"></app-swppp-map>
        @if (error) {
            <div class="alert alert-danger mt-2">{{ error }}</div>
        }
    }
</div>
<div class="modal-footer">
    @if (step > 1) {
        <button type="button" class="btn btn-outline-secondary" (click)="step = step - 1">Back</button>
    }
    @if (step < 4) {
        <button type="button" class="btn btn-primary" [disabled]="step === 1 && (!job || !name)" (click)="step = step + 1">Next</button>
    }
    @if (step === 4) {
        <button type="button" class="btn btn-primary" [disabled]="saving" (click)="create()">Create Site and Continue</button>
    }
</div>
